<div class="contact-top" style="
    background-color: black;
    height: 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 40px;
    box-sizing: border-box;
    color: #fff;
    flex-wrap: nowrap;
    font-weight: 600;
    align-items: center;
  ">
  <p>
    <a routerLink="/subscribe" style="font-size: 14px"> Subscribe to our newsletter</a>
  </p>
  <p>
    <a href="tel:02087747298"><span style="font-size: 14px; text-decoration: none;">020 8774 7298 </span>
    </a>
    <span class="barre">|</span>
    <a href="mailto:enquiries@luxuryholidaysdirect.com"><span style="font-size: 14px">
        enquiries@luxuryholidaysdirect.com</span></a>
  </p>
</div>
<nav class="navbar navbar-expand-lg" id="navbar-menu" #navbar>
  <br />
  <div class="container-fluid mx-0 px-0">
    <div class="">
      <a class="logo" routerLink="/" routerLinkActive="active">
        <img src="assets/images/lhd/LUXURY white.png" class="logo-img" alt="Luxury Holidays Direct" width="136px" height="81px"
          fetchpriority="high" decoding="async" loading="eager" />
      </a>
    </div>
    <!-- Button -->
    <button (click)="navBarShown = !navBarShown" class="navbar-toggler" type="button" data-bs-toggle="collapse"
      data-bs-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
      <fa-icon [icon]="faBars"></fa-icon>
    </button>
    <!-- Menu -->
    <div class="collapse navbar-collapse" id="navbar" [class.show]="navBarShown">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item as">
          <a class="nav-link" aria-current="page" routerLink="/" routerLinkActive="active"
            (click)="navBarShown = !navBarShown">HOME</a>
          <div class="underline"></div>
        </li>
        <li class="nav-item as">
          <a class="nav-link" aria-current="page" routerLink="/about-us" routerLinkActive="active" id="needwid"
            style="text-wrap: nowrap" (click)="navBarShown = !navBarShown">ABOUT US</a>

          <div class="underline"></div>
        </li>
        <li class="nav-item dropdown drop_1 as">
          <a class="nav-link dropdown-toggle" [class.show]="destinationMenuShown" role="button"
            data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"
            (click)="destinationMenuShown = !destinationMenuShown">DESTINATIONS <span
              class="icon icon1">&raquo;</span></a>
          <ul class="dropdown-menu dropdown-menu1" [class.show]="destinationMenuShown"
            [class.hide]="!destinationMenuShown" id="navbar2">
            <li class="dropdown-submenu dropdown" *ngFor="let continent of continents | keyvalue"
              style="font-size: 1rem !important">
              <a (click)="
                  activeSubMenu === continent.key
                    ? (activeSubMenu = undefined)
                    : (activeSubMenu = continent.key)
                " id="africa-nav-dropdown" class="dropdown-item dropdown-toggle"
                [class.show]="activeSubMenu === continent.key" data-bs-toggle="dropdown" aria-expanded="false"
                tabindex="0">{{ continent.key }} <span class="icon">&raquo;</span>
              </a>
              <ul class="dropdown-menu dropdown-menu2" [class.show]="activeSubMenu === continent.key">
                <li>
                  <a [routerLink]="
                      isTouringDestination(destination)
                        ? [
                            '/touring',
                            destination.destination.toLowerCase().split(' ').join('-'),
                            destination.destinationId
                          ]
                        : [
                            '/destinations',
                            'luxury-hotels-in-' +
                              destination.destination
                                .toLowerCase()
                                .split(' ')
                                .join('-'),
                            destination.destinationId
                          ]
                    " data-rr-ui-dropdown-item="" class="dropdown-item" *ngFor="let destination of continent.value"
                    id="{{ destination.destinationId }}" onclick="hideDropdownToggle()">{{ destination.destination
                    }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="nav-item as">
          <a class="nav-link" routerLink="/offers-deals" routerLinkActive="active"
            (click)="navBarShown = !navBarShown">OFFERS&DEALS</a>
          <div class="underline"></div>
        </li>
        <li class="nav-item as">
          <a class="nav-link" style="text-wrap: nowrap" routerLink="/weddings-honeymoons" routerLinkActive="active"
            id="honey" (click)="navBarShown = !navBarShown">HONEYMOON INSPIRATION</a>
          <div class="underline"></div>
        </li>
        <li class="nav-item as">
          <a class="nav-link" routerLink="/tours" routerLinkActive="active"
            (click)="navBarShown = !navBarShown">TOURS</a>
          <div class="underline"></div>
        </li>
        <li class="nav-item as">
          <a class="nav-link" routerLink="/request-quote" routerLinkActive="active"
            (click)="navBarShown = !navBarShown">REQUEST A QUOTE</a>
          <div class="underline"></div>
        </li>
        <li class="nav-item as" style="text-align: center">
          <a class="nav-link" routerLink="/blog" routerLinkActive="active" (click)="navBarShown = !navBarShown">LUXURY
            BLOG ROOM</a>
          <div class="underline"></div>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div class="repere" #stickyTrigger id="top"></div>
<div class="whatsapp">
  <div class="responsable" *ngIf="hideResponsable">
    <div class="btn-close-img" (click)="hideResponsableElement()">✕</div>
    <img src="assets/images/lhd/responsable.webp" alt="Responsable Luxury holidays direct" class="responsable-img"
      height="65" width="65" />
    <!-- (click)="sendMessageToWhatsApp()"<p>Chat with our responsable</p> -->
  </div>
  <div (click)="sendMessageToWhatsApp()" class="custom-whatsapp-btn">
    <img src="assets/images/lhd/whatsapp.png" alt="WhatsApp" class="logo-whatsApp" height="117" width="117" />
  </div>
</div>